jQuery(function () {
  const domReady = (cb) => {
    if (typeof wp !== "undefined" && wp.domReady) wp.domReady(cb);
    else cb();
  };

  const once = (eventName, cb) => {
    document.addEventListener(eventName, cb, { once: true });
  };

  const whenGsapReady = (cb) => {
    if (window.gsap) return cb();
    once("longevity:gsap-ready", cb);
  };

  const whenScrollReady = (cb) => {
    let ran = false;
    const runOnce = () => {
      if (ran) return;
      ran = true;
      cb();
    };
    once("longevity:scroll-ready", runOnce);
    setTimeout(runOnce, 0);
  };

  domReady(() => {
    whenGsapReady(() => {
      whenScrollReady(() => {
        initExpertVoiceArchive();
      });
    });
  });

  function initExpertVoiceArchive() {
    const roots = document.querySelectorAll(".js-expert-voice-archive");
    if (!roots.length) return;

    if (document.body.classList.contains("block-editor-page")) {
      roots.forEach((root) => {
        root.querySelectorAll(".js-eva-item").forEach((el) => {
          el.style.opacity = "1";
          el.style.visibility = "visible";
        });
      });
      return;
    }

    const gsap = window.gsap;
    if (!gsap) return;

    const ScrollTrigger =
      window.ScrollTrigger ||
      (gsap.core && gsap.core.globals && gsap.core.globals().ScrollTrigger) ||
      null;

    if (ScrollTrigger && gsap.registerPlugin) {
      try {
        gsap.registerPlugin(ScrollTrigger);
      } catch (e) {}
    }

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    roots.forEach((root) => {
      if (root.dataset.evaBound === "1") return;
      root.dataset.evaBound = "1";

      const items = root.querySelectorAll(".js-eva-item");
      if (items.length && !reduceMotion) {
        gsap.set(items, { autoAlpha: 0, y: 16 });
        const vars = {
          autoAlpha: 1,
          y: 0,
          duration: 0.85,
          ease: "power3.out",
          stagger: 0.07,
          clearProps: "transform",
        };
        if (ScrollTrigger) {
          vars.scrollTrigger = {
            trigger: root,
            start: "top 78%",
            once: true,
            invalidateOnRefresh: true,
          };
        }
        gsap.to(items, vars);
      } else if (items.length) {
        gsap.set(items, { autoAlpha: 1, y: 0, clearProps: "transform" });
      }

      root.addEventListener("click", (e) => {
        const btn = e.target.closest(".eva__filter");
        if (!btn || !root.contains(btn)) return;

        const term = btn.getAttribute("data-eva-term") || "all";
        const grid = root.querySelector(".js-eva-grid");
        if (!grid) return;

        root.querySelectorAll(".eva__filter").forEach((b) => {
          const on = b === btn;
          b.classList.toggle("is-active", on);
          b.setAttribute("aria-selected", on ? "true" : "false");
        });

        const fd = new FormData();
        fd.append("action", root.dataset.evaAction || "nl_expert_voice_archive");
        fd.append("nonce", root.dataset.evaNonce || "");
        fd.append("term", term);
        fd.append("per_page", root.dataset.evaPpp || "9");

        grid.classList.add("is-loading");
        grid.style.opacity = "0.55";
        grid.style.pointerEvents = "none";

        fetch(root.dataset.evaEndpoint || "/wp-admin/admin-ajax.php", {
          method: "POST",
          body: fd,
          credentials: "same-origin",
        })
          .then((r) => r.json())
          .then((json) => {
            grid.classList.remove("is-loading");
            grid.style.opacity = "1";
            grid.style.pointerEvents = "";
            if (!json || !json.success || typeof json.data?.html !== "string") {
              return;
            }
            grid.innerHTML = json.data.html;
            const cards = grid.querySelectorAll(".js-eva-item");
            if (cards.length && gsap && !reduceMotion) {
              gsap.fromTo(
                cards,
                { autoAlpha: 0, y: 12 },
                {
                  autoAlpha: 1,
                  y: 0,
                  duration: 0.45,
                  ease: "power2.out",
                  stagger: 0.05,
                  clearProps: "transform",
                },
              );
            } else if (cards.length) {
              gsap.set(cards, { autoAlpha: 1, y: 0 });
            }
          })
          .catch(() => {
            grid.classList.remove("is-loading");
            grid.style.opacity = "1";
            grid.style.pointerEvents = "";
          });
      });
    });
  }
});
